import { ToastMessageContext } from "lib/contexts/message_context";
import LineCustomerService from "lib/services/api/admin/line/line_customer_client_new";
import MySmsServices from "lib/services/api/sms/my_sms_service";
import { getOrganisationId } from "lib/utils/common_utils";
import React, { useContext, useEffect, useState } from "react";

const useGetReportFormDropdowns = () => {
  const message = useContext(ToastMessageContext);

  const [dropdownOptions, setDropdownOptions] = useState({});

  const [loading, setLoading] = useState(false);

  const getFormDropdownOptions = async () => {
    try {
      setLoading(true);
      const organisation_id = getOrganisationId();

      const [baseResponse, customersResponse, usersResponse] =
        await Promise.all([
          MySmsServices.getBaseStation({
            organisation_id,
            order_by: "station",
          }),
          MySmsServices.getAllCustomersList({ organisation_id }),
          MySmsServices.getUsersList({ organisation_id }),
        ]);

      const transformedBaseOptions =
        baseResponse?.data?.map((base) => {
          return { id: base?.id, value: base?.station };
        }) || [];

      const transformedCustomers =
        customersResponse?.line_customers?.map((customer) => {
          return { id: customer?.line_customer_id, value: customer?.name };
        }) || [];

      const transformedUsers =
        usersResponse?.data?.user?.map((user) => {
          return { id: user?.id, value: user?.user_name };
        }) || [];

      setDropdownOptions({
        user_id: [{ id: "all", value: "All" }, ...transformedUsers],
        base_station_id: [
          { id: "all", value: "All" },
          ...transformedBaseOptions,
        ],
        line_customer_id: [
          { id: "all", value: "All" },
          ...transformedCustomers,
        ],
      });
    } catch (err) {
      message.showToastMessage({
        message: "Something went wrong. Try again!",
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getFormDropdownOptions();
  }, []);

  return { dropdownOptions, loading };
};

export default useGetReportFormDropdowns;
